import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StaffDetails } from '../../model/v2/practice/staffDetails';
import { BaseService } from '../shared/base.service';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  constructor(private baseService: BaseService) { }

  createStaff(staffReq: any): Observable<any> {
    return this.baseService.post<any>(`Staff/CreateStaff`, staffReq);
  }

  updateStaff(staffReq: any): Observable<any> {
    return this.baseService.post<any>(`Staff/UpdateStaff`, staffReq);
  }

  deleteStaff(staffUserId: number): Observable<any> {
    return this.baseService.delete<any>(`Staff/DeleteStaff?staffUserId=${staffUserId}`);
  }

  createPracticeManager(practiceManager: StaffDetails, healthSystemId: number): Observable<any> {
    return this.baseService.post<any>(`HealthSystem/${healthSystemId}/CreatePracticeManager/`, practiceManager);
  }

  removePracticeManager( healthSystemId: number): Observable<any> {
    return this.baseService.post<any>(`HealthSystem/${healthSystemId}/RemovePracticeManager/`, null);
  }
}
